<app-header></app-header>
<div *ngIf="card != null" class="content">
  <div class="form-recharge">
    <div class="main-title"><span>Karta: {{ card.iccid }}</span></div>
    <hr class="dashed-line">
    <form>
      <label for="status">status karty</label>
      <input id="status" maxlength="150" readonly type="text" value="{{ card.status }}"/><br/>

      <label for="msisdn">numer telefonu (MSISDN)</label>
      <input id="msisdn" maxlength="150" readonly type="text" value="{{ card.msisdn }}"/><br/>

      <label for="package">aktualny pakiet</label>
      <input id="package" maxlength="150" readonly type="text" value="{{ card.currentPricePlan.name }}"/><br/>

      <label for="package-active-from">aktywny od</label>
      <input id="package-active-from" maxlength="150" readonly type="text"
             value="{{ card.subscriptionStart | date:'yyyy-MM-dd' }}"/><br/>
      <label *ngIf="card.subscriptionEnd" for="package-active-to">aktywny do</label>
      <input *ngIf="card.subscriptionEnd" id="package-active-to" maxlength="150" readonly type="text"
             value="{{ card.subscriptionEnd | date:'yyyy-MM-dd' }}"/><br/>

      <label *ngIf="card.lastUsed" for="package-lastUsed">ostatnio użyto dnia</label>
      <input *ngIf="card.lastUsed" id="package-lastUsed" maxlength="150" readonly type="text"
             value="{{ card.lastUsed | date:'yyyy-MM-dd' }}"/><br/>
      <label *ngIf="card.lastUsedLocation" for="package-lastUsedLocation">Ostatnio użyto w</label>
      <input *ngIf="card.lastUsedLocation" id="package-lastUsedLocation" maxlength="150" readonly type="text"
             value="{{ card.lastUsedLocation }}"/><br/>

      <label for="pinpuk1">PIN 1 / PUK 1</label>
      <input id="pinpuk1" maxlength="150" readonly type="text"
             value="{{ card.pin1 ?? '-' }} / {{ card.puk1 ?? '-' }}"/><br/>
      <label for="pinpuk2">PIN 2 / PUK 2</label>
      <input id="pinpuk2" maxlength="150" readonly type="text"
             value="{{ card.pin2 ?? '-' }} / {{ card.puk2 ?? '-' }}"/><br/>

      <hr class="dashed-line">

      <div *ngIf="card.status === 'activated'" class="recharge-options">
        <div class="title">Aktualne saldo: <b>{{ card.minutesLeft }} minuty, ważne
          do {{ card.validUntil | date:'yyyy-MM-dd' }}</b></div>
        <div class="buttons">
          <button (click)="extend('00-30')">Przedłuż o 30 dni<br/>Cena: 82 USD</button>
          <button (click)="extend('100-00')">Dokup 100 minut<br/>Cena: 153 USD</button>
        </div>
        <div class="buttons">
          <button (click)="extend('200-180')">Przedłuż o 6 m-cy<br/>Liczba minut: 200<br/>Cena: 699 USD</button>
          <button (click)="extend('600-365')">Przedłuż o 12 m-cy<br/>Liczba minut: 600<br/>Cena: 1380 USD</button>
          <button (click)="extend('4000-730')">Przedłuż o 24 m-cy<br/>Liczba minut: 4000<br/>Cena: 4620 USD</button>
        </div>
      </div>
      <br/>
      <div class="groupped">
        <div class="title" s>Ostatnie zdarzenia</div>
        <div class="event-wrapper small75">
          <div class="header">Data<br/>zdarzenia</div>
          <div class="header">Plan taryfowy</div>
          <div class="header">Usługa</div>
          <div class="header">Dokąd</div>
          <div class="header">Zużyto</div>

          <ng-container *ngFor="let cdr of cdrs">
            <div>{{ cdr.cdrTimestamp | date:'yyyy-MM-dd HH:mm:ss' }}</div>
            <div>{{ cdr.product }}</div>
            <div>{{ cdr.service }}</div>
            <div>
              <!--
                            <span *ngIf="cdr.originCountry">
                              {{ cdr.originCountry }} ->
                            </span>
                            {{ cdr.destCountry }}<br/>
              -->
              <span *ngIf="cdr.destNumber">
                {{ cdr.destNumber }}
              </span>
              <span *ngIf="cdr.destNetwork && cdr.destNetwork !== 'Cellular'">
                <br/><small>({{ cdr.destNetwork }})</small>
              </span>
              <span *ngIf="cdr.destCountry && cdr.destNetwork === 'Cellular'">
                <br/><small>(-> {{ cdr.destCountry }})</small>
              </span>
            </div>
            <div>
              <span *ngIf="cdr.volumeTotalMin">{{ 60 * cdr.volumeTotalMin | formatMinutes }}
                <br/><small>[min:sek]</small></span>
              <span *ngIf="cdr.volumeTotalMsg">{{ cdr.volumeTotalMsg }}<br/><small>[sms]</small></span>
              <span *ngIf="cdr.volumeTotalData">{{ cdr.volumeTotalData }}<br/><small>[bytes]</small></span>
            </div>
          </ng-container>

        </div>
      </div>

      <br/>

      <div class="buttons">
        <button (click)="goToDashboard()">Wróć</button>
        <button>Zamów biling</button>
        <button>Odśwież saldo</button>
      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
